/* eslint-disable no-unused-vars */
import {
  Autocomplete,
  FormControl,
  IconButton,
  TableCell,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import {
  DeleteCancelButton,
  DeleteOkButton,
  DeletePermission,
  DeletePermissionText,
  ErrorMessage,
  HistoryHeading,
  HistoryTable,
  TableHeadCell,
  TableHeadTr,
} from "../Volunteer.style";
import { Box } from "@mui/system";
import { ThemButton } from "../../Login/Login.style";
import { useDispatch, useSelector } from "react-redux";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Controller, useForm } from "react-hook-form";
import {
  handleDeletePerClose,
  handleDeletePerOpen,
} from "../../../redux/Reducer/ModalSlice";
import moment from "moment";
import { useQuery } from "@tanstack/react-query";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import SyncLoader from "react-spinners/SyncLoader";
import DeleteModal from "../../modal/DeleteModal";
import { toast, ToastContainer, Zoom } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import currentUser from "../../UserId";
import useProfile from "../../../hooks/useProfile";

const schema = yup.object().shape({
  doh: yup
    .date()
    .required("Date of history is required")
    .max(new Date(), "Date of history must not future date"),
  study: yup.string().required("Study code is required"),
  remarks: yup.string().required("Remarks are required"),
});

export default function HistoryTableAdd() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState();
  const volunteerData = useSelector((state) => state.Modal.val);
  const [historyInfo, setHistoryInfo] = useState({});
  const [autocompleteValue, setAutocompleteValue] = useState(null);
  const [userData, , isError, error] = useProfile();

  //! for custom input
  const [customValue, setCustomValue] = useState("");
  const [isCustom, setIsCustom] = useState(false);

  //! fetching volunteers history list
  const { refetch, data: history = [] } = useQuery({
    queryKey: ["history"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/voluntaryHistoryList/${volunteerData.vol_no}`
      );
      const data = await res.json();
      return data;
    },
  });

  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = (data, e) => {
    const reg1 = data?.doh;
    const dateObj = new Date(reg1);
    const dateStr = dateObj.toLocaleDateString("en-CA");
    setIsLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/api/createVoluntaryHistory`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        vol_no: volunteerData.vol_no,
        study_code: data.study,
        complet_date: dateStr,
        remarks: data.remarks,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          reset();
          setAutocompleteValue(null);
          setCustomValue("");
          setIsCustom(false);
          refetch();
          setIsLoading(false);
        } else {
          toast.error("Study code already exists", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .finally(() => setIsLoading(false));
  };

  //! delete history api
  const DeleteMethodPer = () => {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/deleteVolHistory/${historyInfo.vol_hisno}`,
      {
        method: "GET",
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          const userId = currentUser;
          const volunteerId = volunteerData.vol_no;
          const volunteerName = volunteerData.full_name;
          const full_name = userData.full_name;
          const deletedHistoryItem = {
            vol_hisno: historyInfo.vol_hisno,
            study_code: historyInfo.study_code,
            complet_date: historyInfo.complet_date,
            remarks: historyInfo.remarks,
          };
          const existingDeletedHistory = JSON.parse(
            localStorage.getItem("deletedHistory") || "[]"
          );
          existingDeletedHistory.push({
            userId,
            full_name,
            volunteerId,
            volunteerName,
            ...deletedHistoryItem,
          });
          localStorage.setItem(
            "deletedHistory",
            JSON.stringify(existingDeletedHistory)
          );

          refetch();
          dispatch(handleDeletePerClose());
        } else {
          toast.error("Volunteer history not Delete try again !", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  //! delete history method
  const DeleteMethod = (history) => {
    dispatch(handleDeletePerOpen());
    setHistoryInfo(history);
  };

  //! fetching study list
  const { data: studyInfo = [] } = useQuery({
    queryKey: ["studyInfo"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/studyDropdown`
      );
      const data = await res.json();
      return data;
    },
  });

  //! fetching remakrs list
  const { data: remarksInfo = [] } = useQuery({
    queryKey: ["remarksInfo"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/get-remarks`
      );
      const data = await res.json();
      console.log("history modal ", data);
      return data;
    },
  });

  const studyCodeOptions = studyInfo?.map((study) => ({
    label: study.protocol_title,
    value: study.study_code,
  }));

  const remarksOptions = remarksInfo?.map((remark) => ({
    label: remark.remark_id,
    value: remark.remarks_name,
  }));

  console.log("remark options ", remarksOptions);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <HistoryHeading
          style={{
            marginTop: "-1rem",
          }}
        >
          Add New History
        </HistoryHeading>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(15rem, 1fr))",
            gap: "1rem",
          }}
        >
          {/* //! select study */}
          {/* <div style={{ marginTop: "-.5rem", width: "100%" }}>
            <FormControl style={{ width: "100%" }}>
              <Controller
                name="study"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <Autocomplete
                    id="study-autocomplete"
                    options={studyCodeOptions}
                    getOptionLabel={(option) => option.value}
                    value={field}
                    onChange={(e, newValue) => {
                      field.onChange(newValue?.value);
                    }}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        fullWidth
                        {...params}
                        label="Select Study"
                        variant="standard"
                        error={!!errors.study}
                        helperText={errors.study ? errors.study.message : ""}
                      />
                    )}
                  />
                )}
              />
            </FormControl>
          </div> */}

          <div style={{ marginTop: "-.5rem", width: "100%" }}>
            <FormControl style={{ width: "100%" }}>
              <Controller
                name="study"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <Autocomplete
                    id="study-autocomplete"
                    options={studyCodeOptions}
                    getOptionLabel={(option) => option.label} // Show label in dropdown
                    value={
                      studyCodeOptions.find(
                        (opt) => opt.value === field.value
                      ) || null
                    } // Match value to object
                    onChange={(e, newValue) => {
                      field.onChange(newValue ? newValue.value : ""); // Store only value
                    }}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        fullWidth
                        {...params}
                        label="Select Study"
                        variant="standard"
                        error={!!errors.study}
                        helperText={errors.study ? errors.study.message : ""}
                      />
                    )}
                  />
                )}
              />
            </FormControl>
          </div>

          {/* //! picking date */}
          <div>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Controller
                name="doh"
                control={control}
                defaultValue={new Date().toLocaleDateString("en-CA")}
                render={({ field }) => (
                  <>
                    <DesktopDatePicker
                      label="Date of history"
                      maxDate={new Date()}
                      inputFormat="DD MMM YYYY"
                      value={field.value}
                      onChange={(date) => field.onChange(date)}
                      renderInput={(params) => (
                        <TextField fullWidth size="small" {...params} />
                      )}
                    />
                    {errors.doh && (
                      <ErrorMessage>{errors.doh.message}</ErrorMessage>
                    )}
                  </>
                )}
              />
            </LocalizationProvider>
          </div>

          {/* //! outcome of the trials */}
          <div style={{ marginTop: "-.5rem", width: "100%" }}>
            <FormControl style={{ width: "100%" }}>
              <Controller
                name="remarks"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <>
                    <Autocomplete
                      id="remarks-autocomplete"
                      options={[
                        ...remarksOptions,
                        { value: "Others", label: "Others" },
                      ]}
                      getOptionLabel={(option) => option.value || option.value}
                      value={
                        isCustom
                          ? { value: "Others", label: "Others" }
                          : remarksOptions.find(
                              (opt) => opt.value === field.value
                            ) || null
                      }
                      onChange={(e, newValue) => {
                        if (newValue?.value === "Others") {
                          setIsCustom(true);
                          field.onChange("");
                        } else {
                          setIsCustom(false);
                          field.onChange(newValue?.value);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          fullWidth
                          {...params}
                          label="Outcome of last trial"
                          variant="standard"
                          error={!!errors.remarks}
                          helperText={
                            errors.remarks ? errors.remarks.message : ""
                          }
                        />
                      )}
                    />
                    {/* //! input field for others */}
                    {isCustom && (
                      <TextField
                        size="small"
                        fullWidth
                        variant="standard"
                        label="Enter custom remarks"
                        value={customValue}
                        onChange={(e) => {
                          setCustomValue(e.target.value);
                          field.onChange(e.target.value);
                        }}
                        style={{ marginTop: "1rem" }}
                      />
                    )}
                  </>
                )}
              />
            </FormControl>
          </div>
        </div>

        {/* //! add history button */}
        <Box
          marginTop="20px"
          style={{
            margin: "1.5rem 1.5rem 0 1.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem",
          }}
        >
          {isLoading ? (
            <ThemButton>
              <SyncLoader color="#FFFFFF" size={8} />
            </ThemButton>
          ) : (
            <ThemButton type="submit">Add History</ThemButton>
          )}
        </Box>

        {/*//! notification toast */}
        <ToastContainer
          autoClose={2500}
          limit={1}
          transition={Zoom}
          toastStyle={{ border: "2px solid crimson" }}
        />

        {/* //! showing history lists */}
        <HistoryHeading>History List</HistoryHeading>
        <HistoryTable>
          <thead>
            <TableHeadTr>
              <TableHeadCell>SL No.</TableHeadCell>
              <TableHeadCell>Study Code</TableHeadCell>
              <TableHeadCell>Date of Last IMP Intake</TableHeadCell>
              <TableHeadCell>Outcome of last trial</TableHeadCell>
              <TableHeadCell>Remove</TableHeadCell>
            </TableHeadTr>
          </thead>
          <tbody>
            {history.map((history, index) => (
              <tr key={index}>
                <TableCell size="small">{index + 1}</TableCell>
                <TableCell size="small">{history.study_code}</TableCell>
                <TableCell size="small">
                  {moment(history.complet_date).format("DD MMM YYYY")}
                </TableCell>
                <TableCell size="small">{history.remarks}</TableCell>
                <TableCell size="small">
                  <IconButton
                    size="small"
                    sx={{
                      color: " red",
                    }}
                    onClick={() => DeleteMethod(history)}
                  >
                    <HighlightOffIcon />
                  </IconButton>
                </TableCell>
              </tr>
            ))}
          </tbody>
        </HistoryTable>
      </form>

      {/*//! history delete modal   */}
      <DeleteModal ModalWidth="sm" ModalTitle="History Delete Permission">
        <DeletePermission>
          <DeletePermissionText>Do you Want Delete?</DeletePermissionText>
          <Typography
            variant="h6"
            gutterBottom
            style={{ color: "red", marginBottom: "20px" }}
          >
            (Note: Deletion history will be recorded.)
          </Typography>
          <DeleteCancelButton
            onClick={() => {
              dispatch(handleDeletePerClose());
            }}
          >
            Cancel{" "}
          </DeleteCancelButton>
          <DeleteOkButton onClick={DeleteMethodPer}>OK</DeleteOkButton>
        </DeletePermission>
      </DeleteModal>
    </>
  );
}
